import { DEFAULT_LANGUAGE_CODE } from 'utils/constants';
function getDefaultDesc(desc) {
    if (desc)
        return desc[DEFAULT_LANGUAGE_CODE];
    return undefined;
}
var pubDaoUtils = { getDefaultDesc: getDefaultDesc };
export { pubDaoUtils };
